var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3333 23.6573L14.6666 19.0016L19.3333 14.3442L24 19.0016L19.3333 23.6573Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1182 30.788C32.1448 29.7644 32.1448 28.1062 31.1182 27.0827C30.0915 26.0591 28.4286 26.0591 27.402 27.0827C26.3753 28.1062 26.3753 29.7644 27.402 30.788C28.4286 31.8116 30.0915 31.8116 31.1182 30.788",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.209 7.44533C24.9581 5.90533 22.2375 5 19.3021 5C18.4575 5 17.6346 5.08711 16.8319 5.23022",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2577 6.44356C27.8064 6.44356 26.632 7.61645 26.632 9.06311C26.632 10.5113 27.8095 11.6842 29.2593 11.6858C30.7106 11.6858 31.8851 10.5129 31.8851 9.06622C31.8851 7.618 30.7075 6.44356 29.2577 6.44356",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78325 11.1102C6.24014 13.3565 5.33325 16.0725 5.33325 19.0016C5.33325 19.8447 5.42036 20.666 5.56347 21.4671",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77991 9.06778C6.77991 10.516 7.95435 11.6889 9.40569 11.6873C10.857 11.6873 12.033 10.5129 12.033 9.06467C12.033 7.61645 10.8586 6.44356 9.40724 6.44512C7.95591 6.44512 6.77991 7.61956 6.77991 9.06778",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8833 26.8913C32.4264 24.6451 33.3333 21.9307 33.3333 19.0016C33.3333 18.1584 33.2462 17.3371 33.1031 16.536",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8865 28.9353C31.8865 27.4871 30.7121 26.3142 29.2608 26.3158C27.8094 26.3158 26.6334 27.4902 26.6334 28.9384C26.6334 30.3867 27.8079 31.5596 29.2592 31.558C30.7105 31.5564 31.8865 30.382 31.8865 28.9353",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4575 30.5547C13.7084 32.0947 16.4291 33 19.3644 33C20.2091 33 21.032 32.9129 21.8346 32.7698",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40883 31.5564C10.8602 31.5564 12.0346 30.3836 12.0346 28.9369C12.0346 27.4887 10.857 26.3158 9.40727 26.3142C7.95594 26.3142 6.78149 27.4871 6.78149 28.9338C6.78149 30.382 7.95905 31.5564 9.40883 31.5564",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderGroup);
export default __webpack_public_path__ + "static/media/order-group.48aee8023d45fb860964334859de7fe4.svg";
export { ForwardRef as ReactComponent };